import { Injectable, Inject } from '@angular/core';
import { PerformanceContext } from '../interfaces/mysynch.interfaces';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
// performance-context.service.ts
@Injectable({
  providedIn: 'root'
})
export class PerformanceContextService {
  
  constructor(@Inject('MySynchFactory') private MSF: any) {}
  
  createPerformanceContext(herdId: number | null = null): PerformanceContext {
    
    return {
      transactionId: uuidv4(),
      herdId
    };
  }  
 
}